import { IDetailRawViewProps } from './detail-raw-view.types';

export const DetailRawView = ({ title, subTitle, value }: IDetailRawViewProps) => {
  return (
    <div className="eiq-details-row">
      <div className="eiq-details-row__title">{title}</div>
      {subTitle && (
        <div className="eiq-details-row__title">
          <em>{subTitle}</em>
        </div>
      )}
      <div className="eiq-details-row__text">{value}</div>
    </div>
  );
};
